import React, { useState } from "react";
import { TextField, IconButton, Popover, Typography, InputAdornment, Grid } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

interface InfoIconProps {
    infoText: string;
}

const InfoButton: React.FC<InfoIconProps> = ({ infoText}) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton size="small" onClick={handleOpen} >
                <InfoIcon fontSize="small" color="info" />
            </IconButton>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Typography sx={{ p: 2, maxWidth: 300 }}>{infoText}</Typography>
            </Popover>
        </>
    );
};
export default InfoButton;